angular.module("vgresiduos").controller("IndicationRequestCreateCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `mercado/criar-solicitacao`);
		};
	}
]);
